import Vue from 'vue';
import {
    set,
} from '@/lib/service/storage';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export interface ThirdPlatState {
    info: {
        [key: string]: boolean;
    };
}

const m: Module<ThirdPlatState, RootState> = {
    namespaced: true,
    state: () => ({
        info: {
            joy_run: true,
            gudong: false,
            jian_bu: false,
        },
    }),
    mutations: {
        /**
         * 记录绑定状态
         */
        setInfo(state, info) {
            state.info = info;
        },
    },
    actions: {
        /**
         * 获取绑定状态
         */
        async getInfo({ state, commit }) {
            const response = await Vue.axios.get('/api/v1/third_plat/info');
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setInfo', rdata.data);
            }
            return response.data;
        },
        /**
         * 发起悦跑圈关联
         */
        async joyRunApply({ state, commit }, { source }) {
            const response = await Vue.axios.post('/api/v1/third_plat/joy_run/apply', {
                source,
            });
            return response.data;
        },
        /**
         * 验证悦跑圈关联
         */
        async joyRunAuth({ state, commit }, params) {
            const response = await Vue.axios.post('/api/v1/third_plat/joy_run/auth', params);
            return response.data;
        },
        /**
         * 验证悦跑圈关联
         */
        async joyRunCancel({ state, commit }) {
            const response = await Vue.axios.post('/api/v1/third_plat/joy_run/cancel');
            return response.data;
        },

        /**
         * 发起健步圈关联
         */
        async jianBuApply({ state, commit }, { source }) {
            const response = await Vue.axios.post('/api/v1/third_plat/jian_bu/apply', {
                source,
            });
            return response.data;
        },
        /**
         * 验证健步圈关联
         */
        async jianBuAuth({ state, commit }, params) {
            const response = await Vue.axios.post('/api/v1/third_plat/jian_bu/auth', params);
            return response.data;
        },
        /**
         * 取消健步圈关联
         */
        async jianBuCancel({ state, commit }) {
            const response = await Vue.axios.post('/api/v1/third_plat/jian_bu/cancel');
            return response.data;
        },
        /**
         * 发起咕咚关联
         */
        async gudongApply({ state, commit }, { source }) {
            const response = await Vue.axios.post('/api/v1/third_plat/gudong/apply', {
                source,
            });
            return response.data;
        },
        /**
         * 验证咕咚关联
         */
        async gudongAuth({ state, commit }, params) {
            const response = await Vue.axios.post('/api/v1/third_plat/gudong/auth', params);
            return response.data;
        },
        /**
         * 取消咕咚关联
         */
        async gudongCancel({ state, commit }) {
            const response = await Vue.axios.post('/api/v1/third_plat/gudong/cancel');
            return response.data;
        },
    },
};

export default m;
